import {get} from 'lodash';
import {GET_USER_INFO} from 'shared/college-profile/actions/student';
import {UserType} from 'src/types/enums';

export const setCollegeProfileUserInfo =
  ({institution, type}) =>
  (dispatch) => {
    const subdivision = get(institution, 'mailingAddress.subdivision', null);
    return dispatch({
      type: GET_USER_INFO,
      info: {user: UserType.EDUCATOR, institution, type, state: subdivision},
    });
  };
